(function() {
  const whenIdle = (callback) => {
    if (window.requestIdleCallback) {
      return requestIdleCallback(callback, { timeout: 2000 });
    }
    setTimeout(callback, 1200);
  };

  const loadScript = (src, attrs = {}) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    Object.keys(attrs).forEach((key) => script.setAttribute(key, attrs[key]));
    (document.head || document.body).appendChild(script);
  };

  whenIdle(() => {
    if (window.hj) return;
    window.hj = window.hj || function() { (window.hj.q = window.hj.q || []).push(arguments); };
    window._hjSettings = { hjid: 3790120, hjsv: 6 };
    loadScript('https://static.hotjar.com/c/hotjar-' + window._hjSettings.hjid + '.js?sv=' + window._hjSettings.hjsv);
  });

  whenIdle(() => {
    if (window.yotpo) return;
    loadScript('https://cdn-widgetsrepository.yotpo.com/v1/loader/C29B4EdiGCRZNhoMMlbf23wBiHuJJZTxW47RFuFX', { crossorigin: 'anonymous' });
  });

  whenIdle(() => {
    if (window.Marker) return;
    window.markerConfig = {
      project: '65f11b77e488925ed8962482',
      source: 'snippet'
    };

    (function(e, r) {
      if (!e.__Marker) {
        e.__Marker = {};
        const t = [];
        const n = { __cs: t };
        ["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","setCustomData","on","off"].forEach(function(method) {
          n[method] = function() {
            const args = Array.prototype.slice.call(arguments);
            args.unshift(method);
            t.push(args);
          }
        });
        e.Marker = n;
        loadScript("https://edge.marker.io/latest/shim.js", { crossorigin: "anonymous" });
      }
    })(window, document);
  });
})();
